import type { FC, ReactElement, ReactNode } from "react";
import { Children, isValidElement } from "react";

export type CompoundComponent<P = {}> = FC<{ children?: ReactNode } & P>;

export const getCompoundComponentPropsFactory = (children: ReactNode) => (displayName: string) => {
  return (
    Children.toArray(children)
      .filter<ReactElement>(isValidElement)
      .find((child) => (child.type as any)?.displayName === displayName)?.props ?? null
  );
};
